<div class="container-fluid p-3 mobile-p0">
  <div class="row" style="width: 600px; margin: 0 auto">
    <div class="w-100">
      <div id="email-editor" [innerHTML]="HTMLTemplate.innerHTML | sanitizeHtml: 'html'">
      </div>
    </div>
  </div>
</div>
